import React from 'react';
import '../../assets/scss/SensorList.scss';

class Legend extends React.Component {
    
    constructor(props) {
        super(props);
    }

    renderEnergyList ()  {
        let energyTable = [];

        for (let [key, value] of Object.entries(this.props.availableEnergy)) {   
            
            let name;
            if (this.props.powerTypes[key]){
                name = this.props.powerTypes[key].powerNameDE;
            } else {
                name = "kein Name gefunden"
            }
            
            energyTable.push(
                <>            
                <div className="d-flex flex-row ">
                    <div className="">
                        <div style={{width: '20px', height: '20px', backgroundColor:'#'+value.color, marginRight: '4px' }}>                        
                        </div>
                    </div>
                    <div style={{marginRight:"10px"}}>
                        {name}
                    </div>
                </div>
            </>); 
        }
        return (
            <div className = "d-flex flex-wrap mt-3">

            {energyTable}
            </div>
        );

    }

    render () {
        return (
            <>
                <div className="legend-wrapper d-flex justify-content-center align-items-center">
                    <div 
                     style={{
                        position: 'absolute',
                        top: "65vh",
                        width: "35vw",
                    }}
                    className="legend-card-wrapper card d-flex flex-column px-4 py-2 myLegend">
                        <div className="flex-row text-center">
                            <h3 className="legend-headline text-center">Energiearten</h3>
                            
                        </div>                      
                        {this.renderEnergyList()}
                    </div>
                </div>
            </>
        )
    }
}

export default Legend;